import { Logger } from "../../02_utils/logger";
import { Utils } from "../../02_utils/utils";


export class Link {
  constructor(private $log: Logger, private $utils: Utils) {
    this.anchorLink();
  }

  private anchorLink() {
    const anchorId = window.location.hash;

    if (anchorId) {
      this.goToAnchorLink(anchorId);
    }

    this.handleAnchorLinks();
  }

  private handleAnchorLinks() {
    const anchorLinks: NodeListOf<HTMLAnchorElement> = document.querySelectorAll('.js-anchor-link');

    anchorLinks?.forEach(anchorLink => {
      const anchorId = new URL(anchorLink.href).hash;

      if (!anchorId) {
        return;
      }

      anchorLink.addEventListener('click', (event: Event) => {
        if (!(anchorLink.pathname === window.location.pathname)) {
          return;
        }

        event.preventDefault();

        window.history.replaceState({}, null, anchorLink.href);

        this.goToAnchorLink(anchorId);
      });
    });
  }

  private goToAnchorLink(anchorId: string) {
    try {
      const anchorElement = document.querySelector(`${anchorId}`);

      if (!anchorElement) {
        return;
      }

      const headerHeight = document.querySelector('header')?.clientHeight + 24;

      const top = anchorElement.getBoundingClientRect().top + window.scrollY - headerHeight;

      setTimeout(() => {
        window.scrollTo({
          top: top,
          behavior: 'smooth'
        });
      }, 100); // Delay to ensure the page layout is ready
    } catch (error) {
      return false;
    }
  }
}
